
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class ListGrid extends SiteEntityGrid<ListRow, any> {
        protected getColumnsKey() { return 'Data.List'; }
        protected getDialogType() { return ListDialog; }
        protected getIdProperty() { return ListRow.idProperty; }
        protected getLocalTextPrefix() { return ListRow.localTextPrefix; }
        protected getService() { return ListService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}